import { render } from "./LocatairePage.vue?vue&type=template&id=5f270d97"
import script from "./LocatairePage.vue?vue&type=script&lang=js"
export * from "./LocatairePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__